import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from 'src/app/_models/User';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class LoginServiceService {
userDetails : any;
toggleview : boolean = false;
private currentUserSubject: BehaviorSubject<User>;
public currentUser: Observable<User>;
  constructor(private common: CommonService, private client: HttpClient) { }

  PostLoginDetails(userDetails): Observable<any> {
    userDetails.RememberMe = true;
    return this.client.post<any>(this.common.getApiAddress() + "/Account",userDetails)
    .pipe(
      map<any, any>(r => {
        localStorage.setItem("Islogin","true");
        r.authdata = window.btoa(userDetails.username + ':' + userDetails.password);
        localStorage.setItem('currentUser', JSON.stringify(r));
        this.currentUserSubject.next(r);
        return r;
         
        }),
        catchError(e => {
          localStorage.setItem("Islogin","false");
          return this.common.handleError("Login failed", e);
        })
      );
  }

  ForgetPassword(userDetails): Observable<any> {
    userDetails.RememberMe = true;
    return this.client.post<any>(this.common.getApiAddress() + "/Account/forgetpassword",userDetails)
    .pipe(
      map<any, any>(r => {
      
        console.log(r);
         
        }),
        catchError(e => {
          return this.common.handleError("Unable to send details,Please try again", e);

        })
      );
  }

  CreateUser(userDetails): Observable<any> {
    //userDetails.p.RememberMe = true;
    return this.client.post<any>(this.common.getApiAddress() + "/Account/CreateUser",userDetails)
    .pipe(
      map<any, any>(r => {
      
        return r;
         
        }),
        catchError(e => {
          // localStorage.setItem("Islogin","false");
          return this.common.handleError("User creation failed", e);
        })
      );
  }

  ResetPassword(resetdetails) : Observable<any> {
    //userDetails.p.RememberMe = true;
    return this.client.post<any>(this.common.getApiAddress() + "/Account/resetpassword",resetdetails)
    .pipe(
      map<any, any>(r => {
      
        return r;
         
        }),
        catchError(e => {
          // localStorage.setItem("Islogin","false");
          return this.common.handleError("User creation failed", e);
        })
      );
  }
  gettoggleview(){
    return this.toggleview;
  }

  settoggleview(e){
    this.toggleview = e;
  }
}
